import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Link as ScrollTo } from "react-scroll";
import { useSelector } from "react-redux";
import { FaRegTimesCircle } from "react-icons/fa"
import headerStyles from "./DesktopHeader.module.css";
import {
  SearchBar,
  CitySelect,
  Cart,
  Profile,
  UploadPrescription,
  CallUs,
  Radiology,
} from "./DesktopHeaderComponents";

const DesktopHeader = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(NaN);
  const [show, setShow] = useState(false);
  const citySelect = useSelector((state) => state.cityOnTopNav.citySelect);
  // console.log(citySelect,"citySelect")
  const bottomBarNavTabs = [
    // {
    //   name: "About",
    //   // href: "https://redcliffelabs.com/about-us",
    //   href: `${process.env.RAZZLE_APP_BASE_URL}/about-us`,
    //   ext: true,
    // },
    {
      name: "Health Packages",
      href: `${process.env.RAZZLE_APP_BASE_URL}/${citySelect ? citySelect?.toLowerCase() : "delhi"}/package/`,
      ext: true,
    },
    {
      name: "Radiology",
      // href: "https://redcliffelabs.com/imaging",
      href: `/imaging`,
      ext: false,
    },
    {
      name: "Our Labs & Network",
      // href: "https://redcliffelabs.com/lab-centre-network",
      href: `/lab-centre-network`,
      ext: true,
    },
    {
      name: "My Health",
      // href: "https://redcliffelabs.com/blog",
      href: `${process.env.RAZZLE_APP_BASE_URL}/myhealth/`,
      ext: true,
    },
    // {
    //   name: "Gift Card",
    //   // href: "https://redcliffelabs.com/gift-card",
    //   href: `${process.env.RAZZLE_APP_BASE_URL}/gift-card`,
    //   ext: true,
    // },
    // {
    //   name: "Media",
    //   // href: "https://redcliffelabs.com/gift-card",
    //   href: `${process.env.RAZZLE_APP_BASE_URL}/media`,
    //   ext: true,
    // },
    // {
    //   name: "Contact Us",
    //   // href: "https://redcliffelabs.com/contact-us",
    //   href: `/contact-us`,
    //   ext: false,
    // },
  ];

  useEffect(() => {
    // console.log("process", process);
    let pathname = history.location.pathname;
    let len = bottomBarNavTabs.length;
    for (let i = 0; i < len; i++) {
      if (pathname.includes("/package") || pathname.includes("/tests")) {
        setActiveTab(0)
        break;
      }
      if (pathname === bottomBarNavTabs[i].href) {
        setActiveTab(i);
        break;
      }
    }
  }, []);

  const handelClose = () => {

    setShow(!show);
  };

  return (
    <div className={headerStyles.header_container}>
      {/* DESKTOP HEADER TOP BAR */}
      <div className={headerStyles.header_top_container}>
        <div className={headerStyles.header_top}>
          <div className={headerStyles.logoDiv}>
            <a href="https://redcliffelabs.com">
              <img
                // src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/a0f82e2b-5cee-4694-a972-2514e9bd3694.svg"
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/762d53ff-c9ea-45e1-ab34-2b75f0bb0754.webp"
                width="112"
                height="43"
              // className={headerStyles.img_pos}
              // layout="intrinsic"
              // placeholder="blur"
              />
            </a>
          </div>
          <div className={headerStyles.mid_section}>
            <div className={headerStyles.cityAndSearch}>
              <CitySelect />
              <div style={{ borderRight: "2px solid #2E2E2E", height: "1.5rem" }} />
              <SearchBar />
            </div>
            <Cart />
            <Profile />
          </div>
          <div className={headerStyles.uploadPresPos}>
            <UploadPrescription />
          </div>
          <div className={headerStyles.verticalLine} />
          <CallUs />
        </div>
      </div>
      {/* END DESKTOP HEADER TOP BAR */}

      {/* DESKTOP HEADER BOTTOM BAR */}
      <div className={headerStyles.header_bottom_container}>
        <div className={headerStyles.header_bottom}>
          <div className={headerStyles.navTabsContainer}>
            {bottomBarNavTabs.map((tab, index) => {
              if (index === 1) {
                return (
                  <div key={index}>
                    <Radiology />
                  </div>
                );
              }
              if (tab.ext === false) {
                return (
                  <Link to={tab.href} key={index}>
                    <div
                      className={`${headerStyles.navTab}
                        ${activeTab === index ? headerStyles.navTabActive : ""}
                      `}
                      onClick={() => setActiveTab(index)}
                    >
                      <span
                        className={`${headerStyles.navTabText}
                          ${activeTab === index
                            ? headerStyles.navTabTextActive
                            : ""
                          }
                        `}
                      >
                        {tab.name}
                      </span>
                    </div>
                  </Link>
                );
              } else {
                return (
                  <a href={tab.href} key={index}>
                    <div className={`${headerStyles.navTab}`}>
                      <span className={`${headerStyles.navTabText}`}>
                        {tab.name}
                      </span>
                    </div>
                  </a>
                );
              }
            })}

            {/* FAQs */}
            {/* {history.location.pathname === "/" && (
              <ScrollTo
                className={headerStyles.navTab}
                to="faq"
                offset={-110}
                smooth={true}
                duration={500}
              >
                <span className={headerStyles.navTabText}>FAQs</span>
              </ScrollTo>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopHeader;
